import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../utils/types";
import {
  getModule,
  getCourse,
  getLessonSummary
} from "../../../redux/learner/actions";
import {
  selectModules,
  selectModulesLoaded,
  selectModulesLoading,
  selectCourses,
  selectCoursesLoaded,
  selectCoursesLoading,
  selectLessonSummary,
  selectLessonSummaryLoading,
} from "../../../redux/learner/selector";

const mapStateToProps = (state: StateType) => ({
  modules: selectModules(state),
  loading: selectModulesLoading(state),
  loaded: selectModulesLoaded(state),
  courses: selectCourses(state),
  coursesLoading: selectCoursesLoading(state),
  coursesLoaded: selectCoursesLoaded(state),
  lessonSummary: selectLessonSummary(state),
  lessonSummaryLoading: selectLessonSummaryLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getModule,
      getCourse,
      getLessonSummary,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
